




































import {Component, Prop} from "vue-property-decorator";
import abpbase from "@/lib/abpbase";
import {EMPTY_OBJECT} from "@/lib/appconst";

export enum objectTypeEnum {
    '文档收藏' = 1,
    '文档点赞',
    '回答点赞',
    '提问收藏',
    '点击次数'
}

@Component({name: 'basicPage'})
export default class basicPage extends abpbase {
    @Prop({type: Object, default: EMPTY_OBJECT}) bodyStyle: object;

    objectTypeEnum = objectTypeEnum;

    openUserCenter() {
        this.$router.push({
            name: 'overview'
        })
    }

    logout(e) {
        e.stopPropagation();
        this.$store.commit("app/logout");
        location.reload();
    }

}
